import { Color } from "chart.js";

export const DefaultBackgroundColors: ReadonlyArray<Color> = [
    /*****************************************
        GOOGLE MATERIAL 400 HUES
    ******************************************/
    "#EF5350",
    "#EC407A",
    "#AB47BC",
    "#7E57C2",
    "#5C6BC0",
    "#42A5F5",
    "#29B6F6",
    "#26C6DA",
    "#26A69A",
    "#66BB6A",
    "#9CCC65",
    "#D4E157",
    "#FFEE58",
    "#FFCA28",
    "#FFA726",
    "#FF7043",
];

export const DefaultBorderColors: ReadonlyArray<Color> = [

    /*****************************************
        GOOGLE MATERIAL 500 HUES
    ******************************************/
    "#F44336",
    "#E91E63",
    "#9C27B0",
    "#673AB7",
    "#3F51B5",
    "#3737D5",
    "#0291E3",
    "#1BA3B5",
    "#009688",
    "#49A84D",
    "#71A336",
    "#909C1C",
    "#A69500",
    "#BC8D00",
    "#E37800",
    "#FF5722",
    "#795548",
    "#949494",
    "#607D8B",
];
